import { Paths } from "@/core/constants/paths";
import { ForbiddenScreen } from "@/screens/forbidden";
import { NotFoundScreen } from "@/screens/not-found";
import type { ExtendedRouteObject } from "./types";

export const errorRoutes: ExtendedRouteObject[] = [
  {
    path: Paths.FORBIDDEN,
    element: <ForbiddenScreen />,
    rules: ["public"],
  },
  {
    path: "*",
    element: <NotFoundScreen />,
    rules: ["public"],
  },
];
